/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-compatible company update body.
 *
 * Editable metadata excludes tenantId because tenant identifiers are immutable
 * after tenant creation.
 */
export type TCCompanyUpdateBody = {
    name?: string | null;
    description?: string | null;
    /**
     * Client type - simplified as string
     */
    clientType?: TCCompanyUpdateBody.clientType;
    sector?: string | null;
};
export namespace TCCompanyUpdateBody {
    /**
     * Client type - simplified as string
     */
    export enum clientType {
        GENERAL = 'GENERAL',
        REAL_ESTATE = 'REAL_ESTATE',
    }
}

